module.exports = __webpack_public_path__ + "static/media/shine-icon.edbb10dc.png";